document.addEventListener("x-ymm-filter:loaded", (e) => {
  const detail = e.detail;
  if (!detail) return;

  const titleEl = document.querySelector(
    '[data-ymm-filter-applied="true"] .shopify-section > .m6cl .main-collection__page-title'
  );

  if (titleEl) {
    const selectedValues = detail.selectedValues;
    if (Array.isArray(selectedValues) && selectedValues.every((x) => !!x)) {
      let title = "";
      if (selectedValues.length <= 3) {
        title = selectedValues.join(" ");
      } else {
        const firstThree = selectedValues.slice(0, 3).join(" ");
        const rest = selectedValues.slice(3).join(" - ");
        title = `${firstThree} - ${rest}`;
      }
  
  
      titleEl.textContent = title;
    }
    document.body.setAttribute("data-ymm-filter-title-applied", "true");
  }
});
